import { Container, Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { useParams, withRouter, useHistory } from 'react-router-dom';
import { language } from '../../language';
import DOMPurify from 'dompurify';
import { useIntl, defineMessage } from 'react-intl';
import { submitMessage } from '../../language';

import publicIp from 'react-public-ip';

import * as Survey from 'survey-react';
import axiosInterceptor from '../../services/axiosInterceptor';
import 'survey-react/modern.css';
import CustomConfirmAlert from '../../Components/CustomAlert/CustomConfirmAlert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import submitResponse from '../../services/submitResponse';

Survey.StylesManager.applyTheme('modern');

const onCurrentPageChanged = (survey) => {
    window.scrollTo(0, 0);
};

const StartSurvey = () => {
    const history = useHistory();

    const { id } = useParams();

    const [survey, setSurvey] = useState(null);
    const [ip, setIp] = useState(null);
    const [startTime, setStartTime] = useState(Date.now());
    const [questions, setQuestions] = useState([]);
    const [surveyModel, setSurveyModel] = useState(null);
    const intl = useIntl();
    const messages = defineMessage({
        missingMessageTitle: {
            id: 'New1.missingMessageTitle',
            defaultMessage: 'You have missing questions'
        },
        notFinish1: {
            id: 'New1.notFinished1',
            defaultMessage: 'You have not finish the following questions: '
        },
        notFinish2: {
            id: 'New1.notFinished2',
            defaultMessage:
                'Click on Cancel to return and finish survey, click on OK to submit the survey'
        },
        pleaseAnswer: {
            id: 'New1.pleaseAnswer',
            defaultMessage: 'Please answer the question.'
        }
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("start survey fetchData lang:"+language)
                const response = await axiosInterceptor().get(
                    'survey/' + id + '?lang=' + language +"&autogc="+true
                );

                const q = [];
                response.data.survey.data.pages.forEach((p) => {
                    p.elements.forEach((e) => {
                        if (e.type !== 'html') {
                            q.push(e.name);
                        }
                    });
                });

                setQuestions(q);
                setSurvey(response.data.survey);
                const pages = response.data.survey.data;
                const survey = new Survey.Model(pages);
                survey.locale = language||'fr';
                setSurveyModel(survey);
            } catch (err) {}
            try {
                const ipv4 = (await publicIp.v4()) || '';
                setIp(ipv4);
            } catch (err) {}
        };
        const checkConsent = async () => {
            try {
                const response = await axiosInterceptor().get(
                    'incas/consentAccepted'
                );
                if (!response.data.consentAccepted) {
                    history.push('/consent');
                }
            } catch (e) {
                console.log(e);
                history.push('/consent');
            }
        };
        checkConsent();
        fetchData();
    }, [id]);

    const getDisplay = () => {
        if (surveyModel) {
            return (
                <div className="text-left">
                    <Survey.Survey
                        model={surveyModel}
                        onServerValidateQuestions={surveyValidateQuestion}
                        onCurrentPageChanged={onCurrentPageChanged}
                    />
                </div>
            );
        }
    };
    const surveyValidateQuestion = async (survey, options) => {
        if (!survey.isLastPage) {
            options.complete();
            return;
        }
        const nameToIndex = {};
        let i = 1;
        for (let q of questions) {
            nameToIndex[q] = i;
            i += 1;
        }
        const missingIndex = [];
        const missing = [];
        for (let q in nameToIndex) {
            if (!survey.data.hasOwnProperty(q)) {
                missingIndex.push(nameToIndex[q]);
                missing.push(q);
            }
        }
        let isCompleted = true;
        if (missing.length > 2) isCompleted = false;
        // console.log("questions.length:"+questions.length)
        // console.log("missing.length:"+missing.length)
        // console.log("missing:"+JSON.stringify(missing));
        const missingPrompt = missingIndex.join(',');
        if (missing.length > 0) {
            confirmAlert({
                closeOnEscape: false,
                closeOnClickOutside: false,
                customUI: ({ onClose }) => {
                    return (
                        <CustomConfirmAlert
                            title={intl.formatMessage(
                                messages.missingMessageTitle
                            )}
                            text={
                                intl.formatMessage(messages.notFinish1) +
                                missingPrompt +
                                '. ' +
                                intl.formatMessage(messages.notFinish2)
                            }
                            onClose={() => {
                                let i = 0;
                                for (; i < missing.length; i++) {
                                    options.errors[missing[i]] =
                                        intl.formatMessage(
                                            messages.pleaseAnswer
                                        );
                                }
                                options.complete();
                                onClose();
                            }}
                            onOkay={async () => {
                                await submitResponse(
                                    survey.data,
                                    history,
                                    id,
                                    ip,
                                    startTime,
                                    intl.formatMessage(submitMessage.submitted),
                                    true,
                                    isCompleted // less than 2 answers is not completed, won't set the survey
                                );
                                // history.push('/survey');
                                // onClose();
                            }}
                        ></CustomConfirmAlert>
                    );
                }
            });
            return;
        }
        submitResponse(
            survey.data,
            history,
            id,
            ip,
            startTime,
            intl.formatMessage(submitMessage.submitted),
            true
        );
    };
    return (
        <Container fluid>
            <Row>
                <Col>
                    {survey && (
                        <div>
                            <h2 className="mt-4 text-center">{survey.name}</h2>
                            <br />
                            <h5>{survey.description}</h5>
                            <div
                                className="my-2 px-5 py-4 preview"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        survey.instructions
                                    )
                                }}
                            />
                        </div>
                    )}
                    {getDisplay()}
                </Col>
            </Row>
        </Container>
    );
};

export default withRouter(StartSurvey);
